import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export const LoginMixin = {
    data: () => ({
        user: {
            identifier: '',
            password: '',
            invalidLogin:false
        },
        isLoading: false
    }),
    validations: {
        user: {
            identifier: {
                required
            },
            password: {
                required
            }
        }
    },
    watch: {
        getAuthError: function () {
            if (this.getAuthError) {
                this.isLoading = !this.getAuthError
            }
        }
    },
    computed: {
        ...mapGetters(['getAuthError']),
        isEmptyIdentifier() {
            return (
                this.$v.user.identifier.$dirty && !this.$v.user.identifier.required
            )
        },
        isEmptyPassword() {
            return (
                this.$v.user.password.$dirty && !this.$v.user.password.required
            )
        }
    },
    methods: {
        handlerSubmit(e) {
            e.preventDefault()
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                this.isLoading = true
                this.invalidLogin = false
                this.$store.dispatch('login', this.user)
            }
        },
        closeError() {
            this.isLoading = false
            this.invalidLogin = true
            this.$store.dispatch('resetLoginError')
        }
    }
}
